module.exports = __webpack_public_path__ + "img/ICONE-@.769ed726.svg";